import { render, staticRenderFns } from "./WorkflowExtractedDataFields.vue?vue&type=template&id=5b9bde82&scoped=true"
import script from "./WorkflowExtractedDataFields.vue?vue&type=script&lang=js"
export * from "./WorkflowExtractedDataFields.vue?vue&type=script&lang=js"
import style0 from "./WorkflowExtractedDataFields.vue?vue&type=style&index=0&id=5b9bde82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9bde82",
  null
  
)

export default component.exports